import RestClient from './RestClient';
import { Student } from '../../models';

class Students extends RestClient {
    constructor() {
        super({
            "model": Student,
            "entryPoint": "student",
            "resource": "student",
            "resources": "students",
            "sortBy": "lastname",
        });
    }

    removeParent(student, parent) {
        let url = `/student/remove_parent/id/${student.id}/parent_id/${parent.id}`;
        return this.POST(url)
            .then(response => response.json())
            .then(json => {
                if (json.student)
                    return {
                        ...json,
                        student: new Student(json.student)
                    };
                throw new Error(json.flash?.error?.msg || '');
            });
    }
}

const StudentsApi = new Students();

export default StudentsApi;
